import React from "react";

const Diamond = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" className="diamond">
    <path d="M12 0l2.4 9.6L24 12l-9.6 2.4L12 24l-2.4-9.6L0 12l9.6-2.4z" />
  </svg>
);

export default function GoldDivider({ className = "" }) {
  return (
    <div className={`gold-divider ${className}`} data-testid="gold-divider">
      <span className="line" />
      <Diamond />
      <span className="line right" />
    </div>
  );
}
